/**
 * VisitEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { RegionEntity } from "../RegionEntity";
import { PhaseEntity } from "../PhaseEntity";
import { VisitTypeEntity } from "../VisitTypeEntity";
import { ProjectUserEntity } from "../ProjectUserEntity";
import { DeliveryVisitEntity } from "../DeliveryVisitEntity";
import { VisitMemberEntity } from "../VisitMemberEntity";
import { FormEntity } from "../FormEntity";
import { BugEntity } from "../BugEntity";
import { BugNoteEntity } from "../BugNoteEntity";
import { RemarkEntity } from "../RemarkEntity";
import { ReportGroupEntity } from "../ReportGroupEntity";
import { ReportEntity } from "../ReportEntity";
import { promoimmoEntity } from "../promoimmoEntity";
import { VisitEntity } from "../VisitEntity";
declare global {
    interface EntityTypeMap {
        Visit: VisitEntity;
    }
}
export abstract class VisitGeneratedEntity extends BaseEntity {
    public abstract visitId: string;
    public abstract templateId: string | null;
    public abstract date: Date;
    public abstract creationDate: Date;
    public abstract notes: string | null;
    public abstract object: string | null;
    public abstract complete: boolean | null;
    public abstract nextVisitDate: Date | null;
    public abstract temp: boolean;
    public abstract isVisitToday: boolean;
    public abstract project: ProjectEntity;
    public abstract region: RegionEntity | null;
    public abstract phase: PhaseEntity;
    public abstract visitType: VisitTypeEntity | null;
    public abstract creator: ProjectUserEntity | null;
    public abstract deliveryVisit: DeliveryVisitEntity | null;
    public abstract readonly members: ReadonlyArray<VisitMemberEntity>;
    public abstract readonly forms: ReadonlyArray<FormEntity>;
    public abstract readonly bugs: ReadonlyArray<BugEntity>;
    public abstract readonly closingBugs: ReadonlyArray<BugEntity>;
    public abstract readonly bugNotes: ReadonlyArray<BugNoteEntity>;
    public abstract readonly remarks: ReadonlyArray<RemarkEntity>;
    public abstract readonly closingRemarks: ReadonlyArray<RemarkEntity>;
    public abstract readonly reportGroups: ReadonlyArray<ReportGroupEntity>;
    public abstract readonly reports: ReadonlyArray<ReportEntity>;
    public abstract promoimmo: promoimmoEntity | null;
}
